<template>
  <div class="pg-custorm-them-configr" ref="eleRef">
    <slot></slot>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'

const props = defineProps({
  customThem: Object,
})

const eleRef = ref(null)
onMounted(() => {
  if (props.customThem) {
    Object.keys(props.customThem).forEach((key) => {
      eleRef.value.style.setProperty(key, props.customThem[key])
    })
  }
})
</script>
<style lang="scss">
.pg-custorm-them-configr {
  width: 100%;
  height: 100%;
}
</style>
